module.exports = __webpack_public_path__ + "img/e030814.png";